import { render, staticRenderFns } from "./VirtualEventContainer.vue?vue&type=template&id=d425b2f2&"
import script from "./VirtualEventContainer.vue?vue&type=script&lang=js&"
export * from "./VirtualEventContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports